export default __webpack_public_path__ + "static/media/Resposta.f3fec87a.svg";